import { Button } from "primereact/button";
import { useEffect, useRef, useState } from "react";
import { Store, pharmaNationalIdNumber } from "../../static/pharma.model";
import { getPharmaListNationalIdNumber } from "../../service/pharmaList.service";
import { InputText } from "primereact/inputtext";
import { MapProps } from "../Pharmacy/map-tab/mapTab.component";
import { Dialog } from "primereact/dialog";
import SignupInfoPharmacy from "../UserSignup/SignupInfoPharmacy/signupInfoPharmacy";
import GoogleMapReact from "google-map-react";
import './associateCard.css'
import { getAllCustomerInfo } from "../../service/allCustomerInfo.service";
import allInfoProfileModel from "../../static/allProfileInfo.model";
import profileModel from "../../static/profile.model";
import { getUserProfile } from "../../service/profile.service";
import { addCreateCustomer, addOrCreateCustomer } from "../../service/addOrCreateCustomer.service";
import { Enum_ValidationString, checkValidationRequiredString } from "../../utilities/common.utilities";
import { googleMapsApiKey } from "../../static/google-map-key";
import LoadingSpinner from "../loading-spinner/loading-spinner";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { fromAddress } from "react-geocode";
import { Toast } from "primereact/toast";
import { CalculateGeoDistance, GetNearlyLocation } from "../../utilities/geo.utilities";
import { APP_ID_PLATFORM, MAXLENGTH_EMAIL, MAXLENGTH_NATIONAL_ID_NUMBER, MAXLENGTH_PHONE } from "../../static/constants";
import AutocompletePharmacy, { Enum_TypeSuggestion, autocompletePharmacyOutputModel } from "../AutocompletePharmacy/autocompletePharmacy";
import PopupGeolocationComponent from "../PopupGeolocation/popupGeolocation.component";
import { useConnectivity } from "../../context/connectivityContext";

type associateCardProp = {
  Card: associateCardPreWriteProp;   // card da cui prendere dati di default, come codice fiscale

  // callback richiamata per indicare che questo componente ha terminato le sue funzioni, 
  // indicando con un oggetto (di tipo associateCardOutputModel) delle informazioni riguardanti le operazioni svolte da
  // questo componente
  OnFinishOperation?: any;           
}

type customButtonProps = {
  position: number
}

type associateCardPreWriteProp = {
  groupCode: string;
  storeCode: string;
  selectedCard: string;
}

export type associateCardOutputModel = {
  addNewCard: boolean;             // Indica se è stata aggiunta una nuova carta
  storeCodeCheckPrivacy?: string;   // Indica al componente padre su quale farmacia deve controllare lo stato della privacy
}

export type PharmacyNationalIdNumber_ItemList = {
  customerIsRegistered: boolean;
  userAlreadyLinkedToCustomer: boolean;
  groupId: number;
  groupName: string;
  store: Store;

  // dati client
  distanceFromPosition?: number;
};

type text = {
  lat: any;
  lng: any;
  text: any;
};

type InputInfoStatus = {
  value: string;
  valid: boolean;
  showError: boolean;
};

const defaultInfoStatus: InputInfoStatus = {
  value: "",
  valid: false,
  showError: false,
};

export default function AssociateCard(props: associateCardProp) {

  var navigationCoords: MapProps = { lat: 0, lng: 0 };
  let listaFarmacieTemp: PharmacyNationalIdNumber_ItemList[] = [];

  const toast = useRef<Toast>(null);
  const [geoLocationActive, setGeoLocationActive] = useState<boolean>(false);

  const [isFirstStep, setIsFirstStep] = useState<boolean>(true);

  // STATE USERNAME

  const [username, setUsername] = useState<string>('');

  // STATE PER FARMACIE

  const [listaFarmacie, setListaFarmacie] = useState<PharmacyNationalIdNumber_ItemList[]>([]);
  const [pharmaSelected, setPharmaSelected] = useState<PharmacyNationalIdNumber_ItemList | null>();
  const [filteredPharma, setFilteredPharma] = useState<PharmacyNationalIdNumber_ItemList[]>();
  const [showErrorPharmacy, setShowErrorPharmacy] = useState<boolean>(false);

  // STATE PER INPUT FORM
  const [name, setName] = useState<InputInfoStatus>(defaultInfoStatus);
  const [surname, setSurname] = useState<InputInfoStatus>(defaultInfoStatus);
  const [nationalIdNumber, setNationalIdNumber] = useState<InputInfoStatus>(defaultInfoStatus);

  const [phone, setPhone] = useState<InputInfoStatus>(defaultInfoStatus);
  const [email, setEmail] = useState<InputInfoStatus>(defaultInfoStatus);
  const [matchEmail, setMatchEmail] = useState<InputInfoStatus>(defaultInfoStatus);
  const [viewMatchEmail, setViewMatchEmail] = useState<boolean>(false);
  const [readOnlyNationalIdNumber, setReadOnlyNationalIdNumber] = useState<boolean>(true);

  const [theme, setTheme] = useState<string>(localStorage.getItem("theme") || "light-blue");

  // CONNESSIONE
  const { isOnline } = useConnectivity();

  // STATE MAPPA
  const [centerMap, setCenterMap] = useState<MapProps>({ lat: 0, lng: 0 });

  const [isGettingCoordinates, setStateGettingCoordinated] =
    useState<boolean>(false);
  const [userCoordinates, setUserCoordinates] = useState<MapProps>({
    lat: 0,
    lng: 0,
  });
  const [showAlertGeoLocalization, setShowAlertGeoLocalization] =
    useState<boolean>(false);
  const [zoom, setZoom] = useState<number>(17);
  const [address, setAddress] = useState<string>('')

  const [showPopupResultAddCard, setShowPopupResultAddCard] = useState<boolean>(false);
  const [loadingPharmacies, setLoadingPharmacies] = useState<boolean>(true);

  const [mapRef, setMapRef] = useState<any>(null);

  const initComponent = async () => {

    let tempNationalIdNumber: string = '';
    let tempMobilePhone: string = '';
    let tempEmail: string = '';

    if(props.Card.selectedCard) {

      await getAllCustomerInfo(props.Card.groupCode, props.Card.storeCode, props.Card.selectedCard).then((allCustomerInfo) => {
        let profile: allInfoProfileModel = allCustomerInfo?.profile;
        tempNationalIdNumber = profile?.taxCode ? profile.taxCode : '';
        tempMobilePhone = profile?.mobilePhone ? profile.mobilePhone : '';
        tempEmail = profile?.email ? profile.email : '';

        setNationalIdNumber({ value: tempNationalIdNumber,valid: true,showError: false } );
        setReadOnlyNationalIdNumber( tempNationalIdNumber ? true : false );
        setPhone({ value: tempMobilePhone,valid: true,showError: false } );
        setEmail({ value: tempEmail,valid: true,showError: false } );
      })

    }

    else {
      setNationalIdNumber({ value: tempNationalIdNumber,valid: true,showError: false } );
      setReadOnlyNationalIdNumber( tempNationalIdNumber ? true : false );
      setPhone({ value: tempMobilePhone,valid: true,showError: false } );
    }

    await getUserProfile().then((profile:profileModel) => {
      if(profile) {
        setName({ value: profile.firstName,valid: true,showError: false }  );
        setSurname({ value: profile.lastName,valid: true,showError: false }  );
  
        setUsername(profile.signInName);
      }

      if(!props.Card.selectedCard) {
        setEmail({ value: profile.email,valid: true,showError: false } );
      }

    })

      if(isOnline) {
        localStorage.removeItem('GET_PHARMA_TAXCODE_LIST_TIME');
        localStorage.removeItem('pharmaTaxCodeList');
      }

      await getPharmaListNationalIdNumber(tempNationalIdNumber).then((data) => {
        let farmacie: PharmacyNationalIdNumber_ItemList[] = [];

        if (data?.length > 0) {
          let temp_data = (data as pharmaNationalIdNumber[]).filter((g) => g.settings.app);
          temp_data?.forEach((g) => {
            let farmacieSingoloGruppo: PharmacyNationalIdNumber_ItemList[] = g.stores.map(
              (f) => {
                let pharmacy: PharmacyNationalIdNumber_ItemList = {
                  customerIsRegistered: g.customerIsRegistered,
                  userAlreadyLinkedToCustomer: g.userAlreadyLinkedToCustomer,
                  groupId: g.groupId,
                  groupName: g.groupName,
                  store: f
                };

                
                if(navigationCoords.lat && navigationCoords.lng) {
                  pharmacy.distanceFromPosition = CalculateGeoDistance(navigationCoords.lat,navigationCoords.lng,f.latitude, f.longitude);
                }

                return pharmacy;
              }
            );

            farmacie = farmacie.concat(farmacieSingoloGruppo);
            listaFarmacieTemp = farmacie;
          });

          setListaFarmacie(farmacie);
        }  // Fine IF farmacie trovate

        setLoadingPharmacies(false);
      })
      .catch(() => setLoadingPharmacies(false))
  }


  useEffect(() => {
    const storedTheme = localStorage.getItem("theme") || "light-blue";
    setTheme(storedTheme);

    navigator.geolocation.getCurrentPosition(setPosition, errorPosition, {enableHighAccuracy: true});
    initComponent();

  }, [isOnline]); // Indico di reindirizzare il componente quando la variabile isOnline cambia valore

    

  // Consente di centrare la posizione, modificando lo zoom in maniera da poter vedere almeno una farmacia
  const centerOnMyPosition = (lat: number, lng: number) => {
    let newCenterMap: MapProps = {lat: lat, lng: lng};

    setUserCoordinates(newCenterMap);  // disegna il pallino tondo con l' animazione

    // Prendo le coordinate di tutte le farmacie
    let coordinates: MapProps[] = listaFarmacie?.map(f => ({ lat: f.store.latitude, lng: f.store.longitude } as MapProps));

    // Recupero le coordinate delle farmacie più vicine
    let coordNearly: MapProps | null= GetNearlyLocation(newCenterMap, coordinates);

    if(coordNearly) {

      let bounds = new mapRef.maps.LatLngBounds();
      bounds.extend(newCenterMap)
      bounds.extend({lat: coordNearly.lat, lng: coordNearly.lng} as MapProps)

      mapRef.map.fitBounds(bounds);

      // Se la centratura è rimasta invariata, imposto il centro e lo zoom dall' oggetto che rappresenta
      // la mappa 
      if(centerMap.lat === newCenterMap.lat && centerMap.lng === newCenterMap.lng) {
        mapRef.map.setCenter({lat: lat, lng: lng})
        mapRef.map.setZoom(mapRef.map.getZoom() - 1)
      } 
      // Altrimenti se la centratura è diversa, posso impostare i nuovi valori direttamente con le variabili legate
      // agli state
      else {
        setCenterMap(newCenterMap);
        setZoom(mapRef.map.getZoom() - 1);
      }
    }

  }

  function setPosition(position: GeolocationPosition,zoom?: number) {

    if (position.coords.latitude && position.coords.longitude) {

      let positionUser: MapProps = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      }

      //setNavigationCoords(positionUser);
      navigationCoords = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      }

      setUserCoordinates(positionUser);
      setCenterMap(positionUser);
      setGeoLocationActive(true);

     if(!isCalculateDistances() && listaFarmacieTemp?.length > 0) {

        let newList: PharmacyNationalIdNumber_ItemList[] = listaFarmacieTemp.map((f: PharmacyNationalIdNumber_ItemList) => {
          let pharmacy: PharmacyNationalIdNumber_ItemList = {
            
            customerIsRegistered: f.customerIsRegistered,
            userAlreadyLinkedToCustomer: f.userAlreadyLinkedToCustomer,
            groupId: f.groupId,
            groupName: f.groupName,
            store: f.store,
            distanceFromPosition: CalculateGeoDistance(position.coords.latitude,position.coords.longitude,f.store.latitude,f.store.longitude)
          }

          return pharmacy;
        })

        setListaFarmacie(newList);
     }
    } 
    else {
      impostaCoordinateAssenzaValori();
    }

    setStateGettingCoordinated(true);

    if(zoom) {
      setZoom(zoom)
    }
  }

  function errorPosition(positionError: GeolocationPositionError): void {
    if(positionError.code === GeolocationPositionError.PERMISSION_DENIED) {
      setShowAlertGeoLocalization(true)
    }
    impostaCoordinateAssenzaValori();
    setStateGettingCoordinated(true);
    setGeoLocationActive(false);
  }

  
  function impostaCoordinateAssenzaValori(): void {
    setCenterMap( { lat: 41.89671, lng: 12.48220 } )
  }

  // controlla se sono state calcolate le distanze tra il punto della posizione (presa dalla geolocalizzazione)
  // e le farmacie
  const isCalculateDistances = (): boolean => {
    return (
      listaFarmacieTemp?.filter(f => f.distanceFromPosition)?.length > 0
    )
  }

  const CustomPosition = (props: customButtonProps) => {
    return(
      <div className=" flex align-items-center ">
        <Button id="researchButton" className="button-icon-signup-compass" icon="bi bi-crosshair"  aria-label="Filter" 
          onClick={() => {onMyPosition()}} > 
        </Button>
      </div>
    )
  }

  const richiediConferma = () => confirmDialog({
    tagKey: 'confirm',
    message: 'Vuoi aggiungere la card al tuo account?',
    header: "Conferma operazione",
    acceptLabel: "Si",
    modal: true,
    className:"  popup-function-dialog",
    accept: () => {
      
      if(pharmaSelected) {
      let request: addOrCreateCustomer = {
        FirstName: name.value,
        LastName: surname.value,
        SignInName: username,
        Email: email.value,
        MobilePhone: phone.value ? phone.value : '',
        NationalIdNumber: nationalIdNumber.value,
        StoreCode: pharmaSelected.store.storeCode,
        GroupId: pharmaSelected.groupId.toString(),
        OverrideIdCreatorPlatformType: APP_ID_PLATFORM, // parametro fisso
      }
      addCreateCustomer(request).then((response)=> {
        if(response.status === 200) {          
          setShowPopupResultAddCard(true);
        }
        if(response.status === 205){
          showWarning(response?.message)
        }
      })

      }
    },
    reject: () => {}
  });

  // Al click del pulsante "Continua"
  const onTerminateFirstStep = () => {
    // Se è stata selezionata una farmacia
    if(pharmaSelected?.store?.name && nationalIdNumber.valid) {

      // Se il customer è già registrato eseguo direttamente chiamata al server
   
      if(pharmaSelected?.customerIsRegistered) {
        
        richiediConferma();
       
      }

      // Altrimenti visualizzo form 
      else {

        window.scrollTo({
          top: 0
        });

        setIsFirstStep(false);
      } 
    }

    else {
      setShowErrorPharmacy(true);
    }
  }

  const onSubmitForm = () => {

    if(isValidForm() && pharmaSelected) {
      richiediConferma();
    }

    else {
      setMatchEmail(s => ({ value: s.value, valid: s.valid, showError: true }));
    }
  } 

  // Controlla la validità del form presente nel secondo step
  // (Visualizzato se scelta una farmacia con customerIsRegistered uguale a false)
  const isValidForm = (): boolean => {
    return (
      name.valid &&
      surname.valid &&
      nationalIdNumber.valid &&
      phone.valid &&
      email.valid &&
      (
        viewMatchEmail
        ? 
        matchEmail.valid 
        :
        true
      )
    )
  }

  async function onChangeNationalIdNumber(NationalIdNumberValue: string) {

    NationalIdNumberValue = NationalIdNumberValue ? NationalIdNumberValue.toUpperCase() : '';
    // per il codice fiscale rimuovo tutti gli spazi
    NationalIdNumberValue = NationalIdNumberValue.replaceAll(' ','');

    let NationalIdNumberInfo: InputInfoStatus = {
      value: NationalIdNumberValue,
      valid: checkValidationRequiredString(
        NationalIdNumberValue,
        Enum_ValidationString.NationalIdNumber
      ),
      showError: nationalIdNumber.showError,
    };
    setNationalIdNumber(NationalIdNumberInfo);
    // setPharmaSelected(null)

    // if(NationalIdNumberInfo.valid) {
    //   await getPharmaListNationalIdNumber(NationalIdNumberValue).then((data) => {
    //     let farmacie: PharmacyNationalIdNumber_ItemList[] = [];
  
    //     if (data?.length > 0) {
    //       let temp_data = (data as pharmaNationalIdNumber[]).filter((g) => g.settings.app);
    //       temp_data?.forEach((g) => {
    //         let farmacieSingoloGruppo: PharmacyNationalIdNumber_ItemList[] = g.stores.map(
    //           (f) => {
    //             return {
    //               groupId: g.groupId,
    //               groupName: g.groupName,
    //               store: f,
    //               customerIsRegistered: g.customerIsRegistered
    //             } as PharmacyNationalIdNumber_ItemList;
    //           }
    //         );
  
    //         farmacie = farmacie.concat(farmacieSingoloGruppo);
    //       });
  
    //       setListaFarmacie(farmacie);
    //     }
    //   }); 
    // }
  }
  function onBlurNationalIdNumber() {
    let blurNationalIdNumberInfo: InputInfoStatus = {
      value: nationalIdNumber.value,
      valid: checkValidationRequiredString(
        nationalIdNumber.value,
        Enum_ValidationString.NationalIdNumber
      ),
      showError: nationalIdNumber.showError,
    };
    blurNationalIdNumberInfo.showError = true;
    setNationalIdNumber(blurNationalIdNumberInfo);
  }

  function getErrorCodiceFiscale(): string {
    let messageError: string = "";
    if (!nationalIdNumber.valid) {
      if (nationalIdNumber.value.length === 0) {
        messageError = "Campo obbligatorio";
      } else {
        messageError = "Codice fiscale non valido";
      }
    }

    return messageError;
  }

  const searchPharmacies = (value: string) => {

    let tempPharmacies: PharmacyNationalIdNumber_ItemList[] = [];
    if(value) {
       tempPharmacies = listaFarmacie?.filter((x) => {
        if (
          x.store?.name?.toLowerCase().includes(value.toLowerCase()) ||
          x.groupName.toLowerCase().includes(value.toLowerCase()) ||
          x.store?.address?.address?.toLowerCase()?.includes(value.toLowerCase()) ||
          x.store?.address?.city
            ?.toString()
            ?.toLowerCase()
            ?.includes(value.toLowerCase()) ||
          x.store?.address?.zipCode
            ?.toString()
            ?.toLowerCase()
            ?.includes(value.toLowerCase())
        ) {
          return x;
        }
      });
    }

    setFilteredPharma(tempPharmacies);

    return tempPharmacies;
  };
  
  const onMyPosition = () => {

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        centerOnMyPosition(pos.coords.latitude,pos.coords.longitude);
      },
      () => {},
      { enableHighAccuracy: true}
    )
  }

  const onResearchAddress = (researchAddress?: string) => {
    let addressSearch: string = researchAddress ? researchAddress : address;

    if (addressSearch) {
      fromAddress(addressSearch)
        .then(({ results }) => {
          const { lat, lng } = results[0].geometry.location;

          if (results[0].types.includes("pharmacy")) {
            researchFromPharmacyList();
          } else {
         

            setCenterMap({lat: lat, lng: lng})

            let positionUser: MapProps = {
              lat: lat,
              lng: lng,
            };

            setUserCoordinates(positionUser);

          //  setZoom(18);

          let coordinates: MapProps[] = listaFarmacie?.map(f => ({ lat: f.store.latitude, lng: f.store.longitude } as MapProps))
          let coordNearly: MapProps | null= GetNearlyLocation(results[0].geometry.location, coordinates);
  
          let pharmacyNearly: PharmacyNationalIdNumber_ItemList | undefined= listaFarmacie
            ?.find(f => f.store.latitude === coordNearly?.lat && f.store.longitude === coordNearly.lng);


       
            let bounds = new mapRef.maps.LatLngBounds();
            bounds.extend({lat: lat, lng: lng} as MapProps)
            bounds.extend({lat: pharmacyNearly?.store.latitude, lng: pharmacyNearly?.store.longitude} as MapProps)

            mapRef.map.fitBounds(bounds);
            setZoom(mapRef.map.getZoom() - 1);

            setFilteredPharma([]);
        
          }
        })
        .catch(() => {
          researchFromPharmacyList();
        });

    } 
    // Se l' indirizzo è vuoto 
    else {

      setFilteredPharma([]);
      setCenterMap({lat: userCoordinates.lat, lng: userCoordinates.lng});
      
      setZoom(17)
      //showWarning("Digita il nome di una farmacia o un indirizzo.");
    }
  };

  const researchFromPharmacyList = (addressValue?: string) => {
     
    // Se l' indirizzo non è valido ma ci sono farmacie
    let pharmacyMatch = addressValue ? searchPharmacies(addressValue) : searchPharmacies(address);

    if (pharmacyMatch && pharmacyMatch?.length > 0) {
      
      let latPharmacy: number = pharmacyMatch[0].store.latitude;
      let lngPharmacy: number = pharmacyMatch[0].store.longitude;

      setCenterMap({ lat: latPharmacy, lng: lngPharmacy })

      if (pharmacyMatch.length === 1) {
        setZoom(17);
      } else {
        setZoom(10);
      }

      if(navigationCoords.lat && navigationCoords.lng) {
        setUserCoordinates(navigationCoords)
      }
    }
    // altrimenti se l' input digitato non ha corrispondenza neanche con le farmacie
    // visualizzo un avviso
    else {
      setFilteredPharma(listaFarmacie);
      showError("Nessun risultato disponibile.");
    }
    
} 
const showWarning = (message: string) => {
toast.current?.show({ severity: 'warn', summary: 'Avviso', detail: message, life: 15000 });
}

const showError = (message: string) => {
toast.current?.show({ severity: 'error', summary: 'Errore', detail: message });
}

  const firstStep = () => {

    const isMarkerPharmacySelected = (
      latMarker: number,
      lngMarker: number
    ): boolean => {
      if (pharmaSelected?.store?.name) {
        return (
          pharmaSelected.store.latitude === latMarker &&
          pharmaSelected.store.longitude === lngMarker
        );
      } else {
        return false;
      }
    };
 
    const handleMarkerClick = (latitudeMarker: number,longitudeMarker: number) => {

      let buttonFullScreen: HTMLButtonElement = document.querySelector('.gm-fullscreen-control') as HTMLButtonElement;
      let refresh: boolean = false;

      // Se è attivo il fullscreen, renderizzo di nuovo la mappa in modo che una volta scelta una farmacia
      // viene rimosso in automatico il fullscreen
      if(buttonFullScreen && (buttonFullScreen.getAttribute('aria-pressed')?.toString() ===  'true')) {
        refresh = true;
        setStateGettingCoordinated(false);
      }


      let pharmacy: PharmacyNationalIdNumber_ItemList | undefined = listaFarmacie
        .find(x=> x.store.latitude === latitudeMarker && x.store.longitude === longitudeMarker);

      if(pharmacy) {

     
         setPharmaSelected(pharmacy);

         let latitude: number = pharmacy.store.latitude;
         let longitude: number = pharmacy.store.longitude;
   
         setCenterMap({lat: latitude, lng: longitude})

         if(refresh) {
           setTimeout(() => {
            setStateGettingCoordinated(true);  // Renderizzo di nuovo la mappa
           })
         }
        
      }
    }

    const MarkerPharma = (text: text) => {

      let width: number = 1.8;
      let height: number = 1.8;

      let markerFiltered: PharmacyNationalIdNumber_ItemList | undefined = undefined

      if(filteredPharma && filteredPharma?.length > 0) {
        markerFiltered = filteredPharma?.find(
          f => f?.store?.latitude === text.lat && f?.store?.longitude === text.lng
        )

        if(markerFiltered) {
          width = 1.8;
          height = 1.8;
        }
        else {
          width = 1.8;
          height = 1.8;
        }
      }

      if(pharmaSelected?.store?.name) {
        // Se è il marker associato alla farmacia selezionata
        if(pharmaSelected.store.latitude === text.lat && pharmaSelected.store.longitude === text.lng) {
          width = 1.4;
          height = 2.1;
        }
      }

    //  let dimensionImage: string = dimension+'rem';
      let translateX = (-width)/2 + 'rem';
      let translateY = (-height)+'rem';
      let dimensionWidth = width+'rem';
      let dimensionHeight = height+'rem';

      return (
        <div className="relative" 
          style={{ top: translateY,left: translateX, zIndex: get_ZIndex_Marker(isMarkerPharmacySelected(text.lat, text.lng), !!markerFiltered) }}>

          <img
            draggable={false}
            style={{ width: dimensionWidth, height: dimensionHeight }}
            src={
              isMarkerPharmacySelected(text.lat, text.lng)
              ?
              "https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi3_hdpi.png"
                : 
                (
                  markerFiltered
                  ?
                  "https://mt.google.com/vt/icon/name=icons/onion/SHARED-mymaps-pin-container-bg_4x.png,icons/onion/SHARED-mymaps-pin-container_4x.png,icons/onion/1899-blank-shape_pin_4x.png&highlight=ff000000,9c27b0,ff000000&scale=2.0"
                  :
                  "https://mt.google.com/vt/icon/name=icons/onion/SHARED-mymaps-pin-container-bg_4x.png,icons/onion/SHARED-mymaps-pin-container_4x.png,icons/onion/1899-blank-shape_pin_4x.png&highlight=ff000000,3949ab,ff000000&scale=2.0"
                )
            }
            alt=""
            onClick={() => confirmMarker(text.lat, text.lng)}
          />
        </div>
      );
    };

    
    // Ritorna un valore di z-index per i marker
    // più alto per il marker selezionato, dopo viene assegnato un valore con i marker associati alla ricerca
    // ed infine agli altri
    const get_ZIndex_Marker = (isSelected: boolean,isInMatchingAutoComplete: boolean): number => {
      let z_index_value: number = 1;

      if(isSelected){
        z_index_value = 3;
      }
      else if(isInMatchingAutoComplete) {
        z_index_value = 2;
      }

      return z_index_value;
    }

    const confirmMarker = (lat: number, lng: number) => {
      let pharmacy: PharmacyNationalIdNumber_ItemList | undefined= listaFarmacie?.find(
        f => f.store.latitude === lat && f.store.longitude === lng
      )

      if (pharmaSelected?.store?.name !== pharmacy?.store?.name) {

        confirmDialog({
          message: () => (
            <>

            <div className="mt-2">
              <div>
                <strong> {pharmacy?.store?.name} </strong>
              </div>
              <small className="ml-2">
                {" "}
                {pharmacy?.store?.address.address +
                  " " +
                  pharmacy?.store?.address.city}{" "}
              </small>

              {/* <Divider />
              <div className="mt-3 text-lg"><strong>Vuoi selezionare la farmacia ?</strong></div> */}
            </div>
            </>
          ),
          header: "Vuoi selezionare la farmacia? ",
          // icon: "pi pi-question-circle text-primary",
          acceptLabel: "Si",
          modal: true,
          accept: () => handleMarkerClick(lat, lng),
        });

      }
  }

    const MarkerPositionUser = (text: text) => (
      <div className="relative">
        <div className="marker-position-user">
          <div className="marker-position-user-bounce1"></div>
          <div className="marker-position-user-bounce2"></div>
        </div>
      </div>
    );

       // Definisci i limiti dell'Italia
       const italyBounds = {
        north: 48.092,
        south: 34.4897,
        west: 6.6273,
        east: 18.7849
      };
    
      const handleApiLoaded = (map: any, maps: any) => {
        const boundsRestriction = new maps.LatLngBounds(
          new maps.LatLng(italyBounds.south, italyBounds.west),
          new maps.LatLng(italyBounds.north, italyBounds.east)
        );
    
        // Imposta i limiti per non trascinare fuori dall'Italia
        map.setOptions({
          restriction: {
            latLngBounds: boundsRestriction,
            strictBounds: true,
          },
        });

        // Prendo le coordinate di tutte le farmacie
        let coordinates: MapProps[] = listaFarmacie?.map(f => ({ lat: f.store.latitude, lng: f.store.longitude } as MapProps));

        // Recupero le coordinate delle farmacie più vicine
        let coordNearly: MapProps | null= GetNearlyLocation(centerMap, coordinates);

        let bounds = new maps.LatLngBounds();
        bounds.extend(centerMap)
        bounds.extend({lat: coordNearly!.lat, lng: coordNearly!.lng} as MapProps)

        map.fitBounds(bounds);

        map.setCenter(centerMap)
        setZoom(map.getZoom() - 1)
      };


    return (
      <>
        <Toast ref={toast} position="top-center" />
        <LoadingSpinner show={loadingPharmacies || (!isGettingCoordinates)} />
        <div className="associate-card-class">

        {
          showAlertGeoLocalization
          ?
          <PopupGeolocationComponent onClose={() => setShowAlertGeoLocalization(false) } />
          :
          <></>
        }


          <div className="flex flex-column w-full">

            {
              (!isOnline)
              ?
              <></>
              :
              isGettingCoordinates && nationalIdNumber.valid && listaFarmacie.length > 0 ? (
                <div className="map-container border-round">
                
                <div className="h-full map-section">
                  {
                  <GoogleMapReact
                    yesIWantToUseGoogleMapApiInternals={true}
                    onGoogleApiLoaded={(map) => {setMapRef(map); handleApiLoaded(map.map, map.maps)} }
                    bootstrapURLKeys={
                      { 
                        key: googleMapsApiKey,
                        language: 'it',
                        region: 'it',
                        libraries:['places','visualization'],
                      }
                    }
                    center={centerMap}
                    zoom={zoom}
                    options={{
                      fullscreenControlOptions: {
                        position: 12
                      }
                    }}>

                     {listaFarmacie.map( (item:PharmacyNationalIdNumber_ItemList,index: number) => 
                      <MarkerPharma
                      key={index}
                      lat={item.store.latitude}
                      lng={item.store.longitude}
                      text={item.store.name}/>
                      )  
                     }
                     <MarkerPositionUser 
                     lat={userCoordinates.lat}
                     lng={userCoordinates.lng}
                     text={'TU'}/>


                  </GoogleMapReact>


                  // : <></>
                  }
                  {
                    geoLocationActive
                    ?
                      <CustomPosition position={4} />
                    :
                    <></>
                  }
                </div>
                  
                  {/* 
                    Agganciando il messaggio di conferma al div con aria-label="Mappa" posso far uscire il popup di conferma anche quando
                    la mappa è a schermo intero. Senza questa modifica il popup usciva solo quando ci si toglieva dallo schermo intero
                  */}
               
                  <ConfirmDialog className={`theme-${theme } associate-pharamacy-dialog `} appendTo={() => document.querySelectorAll('[aria-label="Mappa"]')[0] as HTMLElement }/>
                  {/* <ConfirmDialog className="associate-pharamacy-dialog" appendTo={() => document.querySelectorAll('[aria-label="Mappa"]')[0] as HTMLElement }/> */}
               
                </div>
              )
              :
              <></>
            }
    

                </div>

          {/* <LoadingSpinner show={pharmacyLoading} /> */}
          <div className="flex flex-column gap-5 ">
            {/*style={{top: '20vh', position: 'relative'}}*/}
            <div className="w-full flex flex-column align-items-start justify-content-start gap-5">
              <div className="flex flex-wrap justify-content-start align-items-start gap-4 w-full">

              {/* codice fiscale precompilato con la carta selezionata */}
                {/* <div className="flex flex-column mt-2 w-full">
                    <span className="p-float-label">
                      <InputText style={{ textTransform: 'uppercase', borderBottom: 'transparent' }}
                        value={nationalIdNumber.value}
                        onChange={(e) => {
                          onChangeNationalIdNumber(e.target.value);
                        }}
                        invalid={
                          !nationalIdNumber.valid && nationalIdNumber.showError
                        }
                        onBlur={() => {
                          onBlurNationalIdNumber();
                        }}
                      />
                      <label htmlFor="CodiceFiscale" style={{ color: 'white' }}>Codice Fiscale</label>
                    </span>

                    {!nationalIdNumber.showError || nationalIdNumber.valid ? (
                      ""
                    ) : (
                      <span>
                        <small className="text-red-600">
                          {" "}
                          {getErrorCodiceFiscale()}{" "}
                        </small>
                      </span>
                    )} 
                  </div> */}

           
                <div className="flex flex-column flex-grow-1 flex ">

                <div className="w-full">
                  
                {
                  nationalIdNumber.valid
                  ?
                  <div>

                  <div className="flex flex-row w-full">

                  <div className="flex-grow-1 flex align-items-center justify-content-center ml-1 mr-1 relative">

                  {/* <AutoComplete
                    inputId="autocomplete-pharmacies-add-card"
                    type="search"
                    field="store.name"
                    placeholder="Cerca farmacia o indirizzo..."
                    loadingIcon="pi pi-spin pi-spinner loading-icon-autocomplete"
                    suggestions={filteredPharma}
                    value={address}
                    completeMethod={(e) => {
                      searchPharmacies(e.query);
                    }}


                    onChange={(e) => {
                      if(!e.target.value) {
                        setAddress('');
                      }
                      else if(typeof(e.target.value) === 'string') {
                        setAddress(e.target.value)
                      }
                      // Se ho scelto la farmacia
                      else if(typeof(e.target.value) === 'object') {
                        let pharmacy: PharmacyNationalIdNumber_ItemList = e.target.value;
                        researchFromPharmacyList(pharmacy.store.name);
                        
                        setPharmaSelected(pharmacy)
                        setAddress('');

                        // rimuovo il focus
                        // to do: vedere alternativa senza timeout
                        setTimeout(() => {
                          document.getElementById('autocomplete-pharmacies-add-card')?.blur();
                        });

                        resetZoomLevel();
                      }

                    }}
                    panelClassName="panel-class-select-pharmacy-cf"
                    
                    itemTemplate={pharmacyOptionTemplate}
                  /> */}

                    {
                      (!loadingPharmacies) && (!listaFarmacie.length)
                      ?
                      <div className="flex flex-column align-content-center">

                         <div className="text-center mt-2 font-bold text-lg">
                            Nessuna Farmacia trovata.
                        </div>

                        {
                          isOnline
                          ?
                          <></>
                          :
                          <div className="mt-2">Verifica la connessione internet.</div>
                        }
                      </div>
                      :
                      <AutocompletePharmacy pharmacies={listaFarmacie} geoLocationActive={geoLocationActive} 
                        address={address} useInfoCustomer={true} panelClassAutocomplete="panel-class-select-pharmacy-cf"
                        onChangeSelection={(e: autocompletePharmacyOutputModel) => {
                          if(e.typeSuggestion === Enum_TypeSuggestion.Pharmacy) {
                            let pharmacy: PharmacyNationalIdNumber_ItemList | undefined = listaFarmacie
                              .find(f => f.store.latitude === e.coord.lat && f.store.longitude === e.coord.lng);

                              if(pharmacy) {
                                researchFromPharmacyList(pharmacy.store.name);
                                setPharmaSelected(pharmacy);
                              }
                          }
                          else {
                            onResearchAddress(e.label)
                          }
                        }}
                    />
                  }

                  </div>

                  {/* <div className="flex-none flex align-items-center justify-content-end mr-1">
                  <Button id="researchButton" className="button-icon-signup" icon="pi pi-search" rounded text raised aria-label="Filter" 
                      onClick={() => {onResearchAddress()}} /> 
                  </div> */}

                  {/* {
                    geoLocationActive
                    ?
                    <div className="flex-none flex align-items-center">
                      <Button id="researchButton" className="button-icon-signup" icon="pi pi-compass" rounded text raised aria-label="Filter" 
                        onClick={() => {onMyPosition()}} > 
                      </Button>
                    </div>
                    :
                    <></>
                  } */}

                  </div>


                  {!showErrorPharmacy || pharmaSelected?.store?.storeCode ? (
                    ""
                  ) : (
                    <span>
                      <small className="text-red-600">Campo obbligatorio</small>
                    </span>
                  )}
                  </div>
                  :
                  <></>
                }
                </div>
                </div>
                <div className="w-full ml-1 mr-1">
                  {pharmaSelected?.store?.name && nationalIdNumber.valid ? (
                    <SignupInfoPharmacy pharmacy={pharmaSelected.store}  />
                  ) : (
                    ""
                  )}
                </div>

              
              </div>

              <div></div>
            </div>
          </div>
        </div>
      </>
    );
  };

  function onChangeName(nameValue: string): void {
    let nameInfo: InputInfoStatus = {
      value: nameValue,
      valid: checkValidationRequiredString(
        nameValue,
        Enum_ValidationString.Any
      ),
      showError: name.showError,
    };
    setName(nameInfo);
  }

  function onBlurName() {
    let blurNameInfo: InputInfoStatus = {
      value: name.value,
      valid: checkValidationRequiredString(
        name.value,
        Enum_ValidationString.Any
      ),
      showError: name.showError,
    };
    blurNameInfo.showError = true;
    setName(blurNameInfo);
  }

  function onChangeSurname(surnameValue: string): void {
    let surnameInfo: InputInfoStatus = {
      value: surnameValue,
      valid: checkValidationRequiredString(
        surnameValue,
        Enum_ValidationString.Any
      ),
      showError: surname.showError,
    };
    setSurname(surnameInfo);
  }
  function onBlurSurname() {
    let blurSurnameInfo: InputInfoStatus = {
      value: surname.value,
      valid: checkValidationRequiredString(
        surname.value,
        Enum_ValidationString.Any
      ),
      showError: surname.showError,
    };
    blurSurnameInfo.showError = true;
    setSurname(blurSurnameInfo);
  }

  function onChangePhone(telefono: string | null) {
    let phoneInput: string = telefono ? telefono.toString() : "";
    let phoneInfo: InputInfoStatus = {
      value: phoneInput,
      valid: checkValidationRequiredString(
        phoneInput,
        Enum_ValidationString.NumberCode
      ),
      showError: phone.showError,
    };
   
    // Nell' aggiunta di una carta, il telefono non è obbligatorio, quindi se non c'è valore 
    // indico che è valido
    if(!telefono) {
      phoneInfo.valid = true;
    }
    setPhone(phoneInfo);
  }
  function onBlurPhone() {
    let blurPhoneInfo: InputInfoStatus = {
      value: phone.value,
      valid: checkValidationRequiredString(
        phone.value,
        Enum_ValidationString.NumberCode
      ),
      showError: phone.showError,
    };
    blurPhoneInfo.showError = true;
    setPhone(blurPhoneInfo);
  }

  function onChangeEmail(emailValue: string) {
    emailValue = emailValue ? emailValue.toLowerCase() : '';
    let EmailInfo: InputInfoStatus = {
      value: emailValue,
      valid: checkValidationRequiredString(
        emailValue,
        Enum_ValidationString.Email
      ),
      showError: email.showError,
    };
    setEmail(EmailInfo);
    setViewMatchEmail(true);
  }
  function onBlurEmail() {
    let blurEmail: InputInfoStatus = {
      value: email.value,
      valid: checkValidationRequiredString(
        email.value,
        Enum_ValidationString.Email
      ),
      showError: email.showError,
    };
    blurEmail.showError = true;
    setEmail(blurEmail);
  }


  function getErrorEmail(): string {
    let messageError: string = "";
    if (!email.valid) {
      if (email.value.length === 0) {
        messageError = "Campo obbligatorio";
      } else {
        messageError = "Indirizzo email non valido";
      }
    }

    return messageError;
  }

  

  function onChangeMatchEmail(valueEmail: string) {

    valueEmail = valueEmail ? valueEmail.toLowerCase() : '';

    let matchEmailInfo: InputInfoStatus = {
      value: valueEmail,
      valid: checkValidationRequiredString(
        valueEmail,
        Enum_ValidationString.Email
      ),
      showError: matchEmail.showError,
    };
    setMatchEmail(matchEmailInfo);

  }
  function onBlurMatchEmail() {
    let blurMatchEmail: InputInfoStatus = {
      value: matchEmail.value,
      valid: checkValidationRequiredString(
        matchEmail.value,
        Enum_ValidationString.Email,
        email.value
      ),
      showError: matchEmail.showError,
    };
    blurMatchEmail.showError = true;
    setMatchEmail(blurMatchEmail);
  }

  function getErrorMatchEmail(): string {
    let messageErrorEmail: string = "";

    if (matchEmail !== email) {
      messageErrorEmail = "L'email non corrisponde";
    } else {
      messageErrorEmail = "Campo obbligatorio";
    }
    return messageErrorEmail;
  }

  const secondStep = () => {
    return (
      <>
        <Toast ref={toast} position="top-center" />
        <div className="associate-card-class">
          <div>
            <div className="flex flex-column gap-5 content-scroll ">
              <div className="w-full flex flex-column align-items-center justify-content-center gap-5 ">
                <div className="w-full flex flex-column align-items-center justify-content-center pos-rel mt-4 ">

                  { /* Sezione farmacia selezionata */ }

                  <div className="w-full flex align-items-center justify-content-center ">
                    <hr className="hr-style " />
                    <div className="box-title ">
                      <i className="pi pi-building mx-1"></i>Farmacia
                    </div>
                  </div>
    
                  <div className="flex justify-content-center gap-3 mb-4 mt-4" style={{ maxWidth: '85vw' }}>
                    <div className="col-12 flex flex-column align-items-center justify-content-center mt-3">

                      <div className="text-lg font-bold mb-2 text-center">{pharmaSelected?.store?.name}</div>

                      <div className="mb-3 mt-1 text-center">
                        <i className="pi pi-map-marker mr-1 " style={{ color: 'white' }}></i>
                        <span className="text-base">
                          {pharmaSelected?.store?.address?.address+' '+pharmaSelected?.store?.address?.city}
                        </span>
                      </div>

                    </div>
                  </div>

                  { /* Fine sezione farmacia selezionata */ }

                  <div className="w-full flex align-items-center justify-content-center ">
                    <hr className="hr-style " />
                    <div className="box-title ">
                      <i className="pi pi-id-card mx-1"></i>Anagrafica 
                    </div>
                  </div>



                  <div className="w-full flex flex-column align-items-center justify-content-center gap-2 pt-6 ">
                    <div className="flex flex-column mb-4 mt-4 input-width" >

                      <span className="p-float-label ">
                        <InputText    
                          className="font-bold"
                          readOnly={true}
                          style={{textTransform: 'capitalize', borderBottom: 'transparent'}}                  
                          value={name.value}
                          // onChange={(e) => {
                          //   onChangeName(e.target.value);
                          // }}
                          // invalid={!name.valid && name.showError}
                          // onBlur={()=> onBlurName()}
                        />
                        <label htmlFor="Nome">Nome</label>
                      </span>

                      {/* {name.valid || !name.showError ? (
                        ""
                      ) : (
                        <span>
                          <small className="text-red-600">
                            Campo obbligatorio
                          </small>
                        </span>
                      )}
                    */ }
                    </div> 

                    <div className="flex flex-column  input-width">
                    
                      <span className="p-float-label">
                        <InputText
                          className="font-bold"
                          readOnly={true}
                          style={{textTransform: 'capitalize', borderBottom: 'transparent'}}
                          value={surname.value}
                          // onChange={(e) => {
                          //   onChangeSurname(e.target.value);
                          // }}
                          // invalid={!surname.valid && surname.showError}
                          // onBlur={() => onBlurSurname()}
                        />
                        <label htmlFor="Cognome">Cognome</label>
                      </span>

                      {/* {surname.valid || !surname.showError ? (
                        ""
                      ) : (
                        <span>
                          <small className="text-red-600">
                            Campo obbligatorio
                          </small>
                        </span>
                      )} */}
                    </div>

                    <div className="w-full flex flex-column align-items-center justify-content-center">
                    <div className="flex flex-column mt-4 mb-2 input-width">
                      {
                        readOnlyNationalIdNumber
                        ?
                        <span className="p-float-label">
                          <InputText 
                            className="font-bold"
                            readOnly={true}
                            style={{ textTransform: 'uppercase', borderBottom: 'transparent' }}
                            value={nationalIdNumber.value}

                          />
                          <label htmlFor="CodiceFiscale" style={{ color: 'white' }}>Codice Fiscale</label>
                        </span>
                        :
                        <div className="flex flex-column input-width w-full">

                          <span className="p-float-label">
                            <InputText
                              value={nationalIdNumber.value}
                              maxLength={MAXLENGTH_NATIONAL_ID_NUMBER}
                              onChange={(e) => {
                                onChangeNationalIdNumber(e.target.value);
                              }}
                              invalid={
                                !nationalIdNumber.valid && nationalIdNumber.showError
                              }
                              onBlur={() => {
                                onBlurNationalIdNumber();
                              }}
                            />
                            <label htmlFor="CodiceFiscale">Codice fiscale*
                              <i className="pi pi-pencil ml-2 text-sm" ></i>
                            </label>
                          </span>

                          {!nationalIdNumber.showError || nationalIdNumber.valid ? (
                            ""
                            ) : (
                            <span>
                              <small className="text-red-600">
                                {" "}
                                {getErrorCodiceFiscale()}{" "}
                              </small>
                            </span>
                          )}

                        </div>
                      }
                    

                    </div>
                    </div>
                  </div>
              </div>

              <div className="w-full flex flex-column align-items-center justify-content-center gap-5 pos-rel ">
                <div className="w-full flex align-items-center justify-content-center mt-1">
                  <hr className="hr-style " />
                  <div className="box-title ">
                    <i className="pi pi-address-book mx-1"></i>Recapiti
                  </div>
                </div>

                <div className="w-full flex flex-column align-items-center justify-content-center gap-5 pt-6 pb-6">
                <div className="flex flex-column input-width">
                  <span className="p-float-label">
                    <InputText
                      type="tel"
                      value={phone.value}
                      keyfilter="pnum"
                      maxLength={MAXLENGTH_PHONE}
                      onChange={(e) => {
                        onChangePhone(e.target?.value ? e.target.value : null);
                      }}
                      invalid={!phone.valid && phone.showError}
                      onBlur={() => {
                        onBlurPhone();
                      }}
                    />
                    <label htmlFor="Telefono">Telefono
                    <i className="pi pi-pencil ml-2 text-sm" ></i>
                    </label>
                    
                  </span>
                  {phone.valid || !phone.showError ? (
                    ""
                  ) : (
                    <span>
                      <small className="text-red-600">
                        {" "}
                        Formato non valido{" "}
                      </small>
                    </span>
                  )}
                </div>

                <div className="flex flex-column input-width">
                  <span className="p-float-label">
                    <InputText 
                      type="email"
                      value={email.value}
                      onChange={(e) => {
                        onChangeEmail(e.target.value);
                      }}
                      invalid={!email.valid && email.showError}
                      onBlur={() => {
                        onBlurEmail();
                      }}
                      keyfilter="email"
                      maxLength={MAXLENGTH_EMAIL}
                    />
                    <label htmlFor="Email">Email*
                    <i className="pi pi-pencil ml-2 text-sm" ></i>
                    </label>
                  </span>

                  {email.valid || !email.showError ? (
                    ""
                  ) : (
                    <span>
                      <small className="text-red-600">
                        {" "}
                        {getErrorEmail()}{" "}
                      </small>
                    </span>
                  )}
                </div>

                {
                  viewMatchEmail
                  ? 
                  <>
                  <div className="flex flex-column input-width">
                  <span className="p-float-label">
                    <InputText
                      type="email"
                      value={matchEmail.value}
                      onChange={(e) => {
                        onChangeMatchEmail(e.target.value);
                      }}
                      invalid={!matchEmail.valid && matchEmail.showError}
                      onBlur={() => {
                        onBlurMatchEmail();
                      }}
                      keyfilter="email"
                      maxLength={MAXLENGTH_EMAIL}
                    />
                    <label htmlFor="ConfermaEmail">Conferma Email*</label>
                  </span>

                  {matchEmail.valid || !matchEmail.showError ? (
                    ""
                  ) : (
                    <span>
                      <small className="text-red-600">
                        {" "} 
                        {getErrorMatchEmail()}{" "}
                      </small>
                    </span>
                  )}
                </div>
                  </>
                  :
                  <></>
                }
              
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </>
      
    )
  }

  const footerContent = (
    <div>
      <Button
        label="Ok"
        icon="pi pi-check"
        onClick={() => {
          setShowPopupResultAddCard(false);
          let statoOperazione: associateCardOutputModel = {
            addNewCard: true,
            storeCodeCheckPrivacy: pharmaSelected!.store!.storeCode
          }

          if(!props.Card.selectedCard) {
            localStorage.removeItem('selectedCard');
          }
          localStorage.setItem('necessaryActionMenu', 'false');
          // avviso il padre che è stata aggiunta una carta e che deve controllare lo stato dei consensi della privacy
          props.OnFinishOperation(statoOperazione)  // avviso il padre che è stata aggiunta una carta
        }}
        autoFocus
      />
    </div>
  );

  return (
    <>
  
      <ConfirmDialog className="" tagKey="confirm" />

      {
         isFirstStep 
         ?
         firstStep()
         :
        secondStep()
      }

      {/* Gestione dei pulsanti */}
      {
        isFirstStep 
        ?
        <div className="flex align-items-center justify-content-end  ">

          
          <div className="button-undo mx-2 mt-4 flex align-items-center justify-content-center" 
            style={{ cursor: "pointer" }}
            onClick={() => {

              let statoOperazione: associateCardOutputModel = {
                addNewCard: false
              };
              props.OnFinishOperation(statoOperazione);
              
            }}>
            ANNULLA
          </div>

          {/* <div className="button-edit mx-2 mt-4 flex align-items-center justify-content-center" 
            onClick={() => onTerminateFirstStep()} >
            CONTINUA
          </div> */}
        <Button
          onClick={
            () => onTerminateFirstStep()
          }
          label={ (pharmaSelected?.customerIsRegistered ? 'AGGIUNGI' : 'CONTINUA') }
          disabled={showErrorPharmacy || !pharmaSelected?.store?.storeCode}
          style={{ borderRadius: "24px" }}
          className=" button-edit mx-2 mt-4 flex align-items-center justify-content-center "
        ></Button>
        </div>
        :
        <div className="flex align-items-center justify-content-end  ">

          <div className="button-undo mx-2 mt-4 flex align-items-center justify-content-center" 
            style={{ cursor: "pointer" }}
            onClick={() =>{

              window.scrollTo({
                top: 0
              });

              setIsFirstStep(true);
            }
            }>
            INDIETRO
          </div>
          <div className="button-edit mx-2 mt-4 flex align-items-center justify-content-center" 
            onClick={() => onSubmitForm()}>
            AGGIUNGI
          </div>
        </div>
      }

      {/* Gestione popup aggiunta carta */}

      <Dialog visible={showPopupResultAddCard} onHide={() => setShowPopupResultAddCard(false)}
        header="Operazione eseguita con successo" 
        style={{ width: '85vw' }}
        closable={false}
        footer={footerContent}
      >
        <p>
          La tua nuova card è stata selezionata ed è pronta all'uso.<br/> Puoi cambiarla in qualsiasi momento dal Menù
        </p>
      </Dialog>
    </>
  );
}
